import React from 'react'

const RoundedTeleportLogoIcon = props => (
  <svg viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect
      x="2"
      y="2"
      width="80"
      height="80"
      rx="40"
      fill="url(#paint0_linear)"
      stroke="#fff"
      strokeWidth="4"
    />
    <path
      d="M51.201 51.812c5.786 0 10.477-4.659 10.477-10.406C61.678 35.66 56.988 31 51.201 31s-10.477 4.659-10.477 10.406c0 5.747 4.69 10.406 10.477 10.406z"
      fill="#fff"
    />
    <path
      d="M32.477 51.812c5.787 0 10.478-4.659 10.478-10.406C42.955 35.66 38.264 31 32.477 31 26.691 31 22 35.659 22 41.406c0 5.747 4.69 10.406 10.477 10.406z"
      fill="#fff"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="-34.654"
        y1="37.167"
        x2="41.346"
        y2="114.475"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7C7599" />
        <stop offset="1" stopColor="#FD9494" />
      </linearGradient>
    </defs>
  </svg>
)

export default RoundedTeleportLogoIcon
